module.exports = __webpack_public_path__ + "img/sp_complete.7f60668a.svg";